var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-contain"},[_c('div',{staticClass:"e-inner"},[_c('img',{staticClass:"sImg",attrs:{"src":"/static/img/error.png"}}),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c156a7c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/error.vue
// module id = null
// module chunks = 